import "./css/board.css";
import { NavLink, Link } from "react-router-dom";
import styled from "styled-components";
import React, { useState, useEffect, useRef } from "react";
import Pagination from "./Pagination";
import newsexample from "./img/gm메디칼올림푸스.jpg";
import axios from "axios";
import SubHeader from "../components/subHeader3";
import i18next from "../config/lang/i18next";

const StyledLink = styled(NavLink)`
width:20%;
cursor:pointer;
font-weight:bold;
color:rgb(126, 126, 126);
display: inline-block;
font-size:1.2rem;
border-right:1px solid gray;
`;
const PRcenter = () => {
  const [search, setSearch] = useState(null);
  const [options, setOption] = useState("subject");
  const [data, setData] = useState([]);
  const [filterData, setfilterData] = useState([]);
  const [isEmpty, setEmpty] = useState(false);
  const [isPage, setIsPage] = useState(false);
  const [isloggedIn, setLoggedIn] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const offset = (page - 1) * limit;
  const onChangeSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const selectHandle = (e) => {
    e.preventDefault();
    setOption(e.target.value);
  };
  const onSearch = (e) => {
    e.preventDefault();

    /*
        axios.get('http://222.101.0.9:5000/boardlist').then((response)=> {
            setData(response.data);
            
        })
        alert(options);
        searchPosts({ page: page, option: options, content: search });
        setSearch('');*/

    if (options === "subject") {
      const filtered = data.filter((itemList) => {
        console.log(itemList);
        return itemList.subject.toUpperCase().includes(search.toUpperCase());
      });
      setfilterData(filtered);
      if (filtered.length === 0) {
        setEmpty(true);
      } else {
        setEmpty(false);
      }
    } else if (options === "content") {
      const filtered = data.filter((itemList) => {
        console.log(itemList);
        return itemList.content.toUpperCase().includes(search.toUpperCase());
      });
      setfilterData(filtered);
      if (filtered.length === 0) {
        setEmpty(true);
      } else {
        setEmpty(false);
      }
    }
  };
  useEffect(() => {
    axios.get("https://thegmmedical.com:5002/api/news").then((response) => {
      setData(response.data);
      setfilterData(response.data);
      if (response.data.length === 0) {
        setEmpty(true);
        console.log(response.data);
      } else {
        console.log("haha");
        setEmpty(false);
        if (response.data.length <= 10) {
          setIsPage(false);
        } else {
          setIsPage(true);
        }
      }
    });
    fetch("https://thegmmedical.com:5002/check", {
      method: "get", // 통신방법
      headers: {
        "content-type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.message === "user존재") {
          setLoggedIn(true);
        }
      })
      .catch(() => {});
  }, []);
  function GetData() {
    const item = Object.values(data).map((item) => (
      <tr>
        <td className="m_dp_n">{item.board_id}</td>
        <td className="m_dp_n"></td>
        <td className="ta_l">
          <a className="bl_link" href="/career/view">
            {item.subject}
          </a>
        </td>
        <td>{item.board_date}</td>
      </tr>
    ));

    return item;
  }

  return (
    <div className="wrapper">
      <SubHeader />
      <div className="">
        <h1 className="headerText">{i18next.t("navbar.3-1")}</h1>
        <div className="board_wrapper">
          <form name="form1" id="form1" method="post">
            <div>
              <div id="content" className="content">
                  <div className="board_container">
                    <div>
                      <div id="content" className="content">
                        <div>
                          <div className="sub_top">
                            <div className="st_navigation">
                              <ul></ul>
                            </div>
                          </div>

                          <div className="board_top">
                              {/*<label>
                            페이지 당 게시물 수:&nbsp;
                            <select
                            type="number"
                            value={limit}
                            onChange={({ target: { value } }) => setLimit(Number(value))}
                            >
                            <option value="10">10</option>
                            <option value="12">12</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            </select>
                        </label>*/}
                              <div className="bt_srch">
                                <div className="bts_slct">
                                  <select
                                    id="u_shcate"
                                    name="search_item"
                                    className="select"
                                    title="검색항목 선택"
                                    value={options || ''}
                                    onChange={selectHandle}
                                  >
                                    <option value="subject">{i18next.t("subject")}</option>
                                    <option value="content">{i18next.t("content")}</option>
                                  </select>
                                </div>
                                <div className="bt_input">
                                  <input
                                    type="text"
                                    id="search_content"
                                    name="search_content"
                                    value={search || ''}
                                    placeholder={i18next.t("placeholder")}
                                    onChange={onChangeSearch}
                                  />
                                </div>

                                <button
                                  type="submit"
                                  className="search_btn"
                                  value="검색"
                                  onClick={onSearch}
                                >
                                  {i18next.t("search")}
                                </button>
                              </div>
                          </div>

                          <div className="board_list">
                            <table>
                              <colgroup>
                                <col className="m_dp_n table_no" />
                                <col className="" />
                                <col className="ta_l" />
                                <col className="m_dp_n table_date" />
                              </colgroup>
                              {/*<thead>
                        <tr>
                            <th className="m_dp_n table_no" scope="col">NO.</th>
                            <th scope="col"></th>
                            <th className="ta_l" scope="col">제목</th>
                            <th className="m_dp_n table_date" scope="col">날짜</th>
                        </tr>
                    </thead>*/}
                              <tbody>
                                {isEmpty && (
                                  <tr style={{ textAlign: "center" }}>
                                    <td colSpan={4}>게시물이 없습니다.</td>
                                  </tr>
                                )}
                                {filterData
                                  .slice(offset, offset + limit)
                                  .map(
                                    ({
                                      board_id,
                                      subject,
                                      board_date,
                                      image_link,
                                      content_txt,
                                    }) => (
                                      <tr key={board_id}>
                                        <td>
                                          <img
                                            src={image_link}
                                            alt="test"
                                            contentEditable="false"
                                          />
                                          {/*<img src={newsexample} alt=""></img>*/}
                                        </td>

                                        <td>
                                          <dd className="boardTitle">
                                            <Link to={`/news/view/${board_id}`}>
                                              {subject}
                                            </Link>
                                          </dd>
                                          <dd className="boardContent">
                                            {content_txt}
                                          </dd>
                                          <dd className="boardDate">
                                            {board_date.substring(5, 10)}
                                          </dd>
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </table>
                            <div style={{width:"100%",textAlign:"right"}}>
                    {isloggedIn && (
                      <Link to="write"
                        style={{
                          padding: "10px 30px",
                          marginTop: "20px",
                          backgroundColor: "#555",
                          color: "white",
                          textAlign: "center",
                          position:"relative",
                          display:"inline-block",
                          width:"105px",
                          cursor: "pointer",
                        }}
                      >
                        글쓰기
                      </Link>
                    )}
                    </div>
                  </div>
                  {isPage && (
                    <div className="paging">
                      <Pagination
                        postsPerPage={limit}
                        totalPosts={filterData.length}
                        page={page}
                        paginate={setPage}
                      ></Pagination>
                      {/*<Pagination
                    total={data.length}
                    limit={limit}
                    page={page}
                    setPage={setPage}
                    />*/}
                    </div>
                  )}
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PRcenter;
